// API Configuration
// In dev: use local proxy '/api' to avoid CORS issues, unless VITE_API_URL is explicitly set
export const API_BASE_URL = import.meta.env.DEV
  ? import.meta.env.VITE_API_URL || '/api'
  : import.meta.env.VITE_API_URL ||
    'https://blog-server-sigma-woad.vercel.app/api';

// Debug log for development
if (import.meta.env.DEV) {
  console.log('API_BASE_URL:', API_BASE_URL);
}

// API Endpoints
export const API_ENDPOINTS = {
  posts: `${API_BASE_URL}/posts`,
  youtube: `${API_BASE_URL}/youtube`,
  categories: `${API_BASE_URL}/categories`,
  tags: `${API_BASE_URL}/tags`,
  comments: `${API_BASE_URL}/comments`,
  auth: `${API_BASE_URL}/auth`,
  upload: `${API_BASE_URL}/upload`,
  ai: `${API_BASE_URL}/ai`,
  settings: `${API_BASE_URL}/settings`,
  newsletter: `${API_BASE_URL}/newsletter`,
  contact: `${API_BASE_URL}/contact`,
  gallery: `${API_BASE_URL}/gallery`,
  bodyPhotos: `${API_BASE_URL}/gallery/body-photos`,
  news: `${API_BASE_URL}/news`,
  newsHeadlines: `${API_BASE_URL}/news/headlines`,
};
